<template>
  <div class="microclass">
    <div class="microclass-header">
      <div class="microclass-header-left">
        <img src="@/assets/newIndex/topicLearning.png" />
        <span>专题学习</span>
      </div>
      <div class="microclass-header-right">
        <div class="microclass-right-text" @click="gotoDisstationsList"><span>查看更多</span><i class="el-icon-arrow-right"></i></div>
      </div>
    </div>
    <!-- 渐变线条 -->
    <div class="gitern"></div>
    <!-- 视频区域 -->

    <div class="microclass-videobox">
      <div
        class="video-box"
        v-for="(item,index) in dissData"
        :key="index"
        @click="gotoDisstations(item.id)"
        v-if="index<8"
      >
        <img :src="item.imgUrl" />
        <div class="video-box-footer">
          <div class="microclass-text onele">{{item.name}}</div>
          <div
            style="color:#999;font-size:14px;"
            v-if="item.source"
          >来源：{{item.source}}</div>
          <div class="micrGs">{{item.des}}</div>
        </div>
      </div>
      <div style="flex: 1;"></div>
    </div>
  </div>
</template>

<script>
import * as diss from '@/api/studyClass/disstation.js';
export default {
  data() {
    return {
      dissData: [],
      dataCount: 0,
    };
  },
  mounted() {
    this.getdissList();
  },
  methods: {
    getdissList() {
      let listQuerys = {
        isHot: false,
        status: 1,
      };

      diss.MoocSpecialLoad(listQuerys).then((res) => {
        this.dissData = res.data;
        this.dataCount = res.count;
      });
    },
    gotoDisstations(id) {
      this.$router.push({
        path: '/mooc/disstations',
        query: {
          id: id,
        },
      });
    },
    gotoDisstationsList() {
      this.$router.push('/mooc/disstationList');
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin comment-box {
  display: flex;
  align-items: center;
  line-height: 20px;
  > img {
    width: 20px;
    height: 20px;
    background: rgba(0, 0, 0, 0);
    opacity: 1;
    margin: 0 4px;
  }
  .comment-box-text {
    width: 13px;
    height: 20px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    opacity: 1;
    margin-right: 1px;
  }
}
.microclass {
  background-color: #fff;
}
.microclass-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0px 19px 6px 21px;
  .microclass-header-left {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    color: #000;
    img{
      height: auto;
      width: 40px;
      margin-right: 13px;
    }
  }
}

.microclass-videobox {
  display: flex;
  flex-wrap: wrap;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  .video-box{
    width: 278px;
    cursor: pointer;
    padding: 6px 7px 20px 7px;
    margin: 0px 16px 27px 0px;
    box-sizing: border-box;
    box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);
    &>img{
      width: 100%;
      height: 156px;
      background: rgba(0, 0, 0, 0);
      cursor: pointer;
      border-radius: 2px;
      margin-bottom: 6px;
    }
    // img:hover {
    //   transform: scale(1.02);
    // }
    .video-box-footer {
      padding: 4px 2px 0px 2px;
      box-sizing: border-box;
      .microclass-text {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
      }
    }
  }
  .video-box:nth-child(4n){
    margin-right: 0px;
  }
}
.micrGs{
  max-height: 98px;
  line-height: 18px;
  font-size: 12px;
  font-weight: 400;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  letter-spacing: 1px;
  color: #666666;
}
.video-box:hover {
  transform: scale(1.01);
  cursor: pointer;
  box-shadow: 1px 1px 5px rgb(156, 154, 154, 0.996);
}
.gitern {
  height: 2px;
  width: 100%;
  background: linear-gradient(139deg, #1492ff, #d51919);
}

.microclass-right-text {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: right;
  cursor: pointer;
  color: #4192FF;
}

.microclass-right-text:hover {
  text-decoration: underline;
}
.onele {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>